import {
  Button as MuiButton,
  ButtonProps as MuiButtonProps,
} from "@mui/material";
import { forwardRef } from "react";

interface LoadingButtonProps extends MuiButtonProps {
  loading?: boolean;
}

const LoadingButton = forwardRef<HTMLButtonElement, LoadingButtonProps>(
  (props, ref) => {
    const { children, loading, ...rest } = props;

    return (
      <MuiButton
        ref={ref}
        variant="contained"
        loading={loading}
        {...rest}
      >
        {children}
      </MuiButton>
    );
  }
);

LoadingButton.displayName = "LoadingButton";

export default LoadingButton;
